import { Box } from '@mui/material';
import { forwardRef } from 'react';
import { Components } from 'react-virtuoso';
import {
  OrderTargetBreakdownListContext,
  OrderTargetBreakdownListRow,
} from '../../orderTargets.types';
import useOrderTargetBreakdownListStyles from './orderTargetBreakdownList.styles';

export const orderTargetBreakdownListComponents: Components<
  OrderTargetBreakdownListRow,
  OrderTargetBreakdownListContext
> = {
  List: forwardRef(({ style, children, context, ...props }, ref) => {
    const { classes } = useOrderTargetBreakdownListStyles(context);

    return (
      <Box {...props} ref={ref} style={style} className={classes.grid}>
        {children}
      </Box>
    );
  }),
  Item: ({ children, item: _item, context, ...props }) => {
    const { classes } = useOrderTargetBreakdownListStyles(context);

    return (
      <Box {...props} className={classes.row}>
        {children}
      </Box>
    );
  },
};
